import { rdrRequests, authorizedRDRequests } from "../httpRequest";

const parksApiRequest = {
    getNearByPopularPlaces: (requestData: any) => rdrRequests.get(`search/popular/places/nearlat/${requestData.latitude}/long/${requestData.longitude}/on/${requestData.startDate}/limit/6`),
    markAsFavouritePlace: (placeId: number) => authorizedRDRequests.post(`webaccessfacility/save/placefavorite`, placeId),
    markAsUnFavouritePlace: (placeId: number) => authorizedRDRequests.post(`webaccessfacility/save/placeunfavorite`, placeId),
    getPlaceFavoriteList: () => authorizedRDRequests.post(`webaccessfacility/getplacefavoritelist`, {})
}

export default parksApiRequest;